module.exports = __webpack_public_path__ + "img/OT134C12_mobile.85f06d4a.png";